var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import { Family } from './Model';
export default class default_1 {
    constructor() {
        this.families = [];
        this.loaded = false;
        this.set = (families) => {
            this.families = families.map(family => new Family(family));
            this.loaded = true;
            return families;
        };
    }
    read(id) {
        if (id)
            return api.get('family/' + id).then(family => new Family(family));
        return api.get('family').then(this.set);
    }
    create(family) {
        return api.post('family', family);
    }
    update(id, family) {
        return api.put('family/' + id, family);
    }
    delete(id) {
        return api.delete('family/' + id);
    }
}
__decorate([
    observable
], default_1.prototype, "families", void 0);
__decorate([
    observable
], default_1.prototype, "loaded", void 0);
__decorate([
    action
], default_1.prototype, "set", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/Families/Store.ts
// module id = 330
// module chunks = 0